import { useState } from "preact/hooks";
import { decode } from "@msgpack/msgpack";
import { decode as decodeLite } from "msgpack-lite";
import { h } from "preact";
import formatHighlight from "json-format-highlight";

export function ValueDisplay(props: { data: DataView | null }) {
    const [displayType, setDisplayType] = useState("hex");
    let value;
    let treatAsInner = false;

    const customDarkColorOptions = {
        keyColor: "#9cdcfe",
        numberColor: "#b5cea8",
        stringColor: "#ce9178",
        trueColor: "#569cd6",
        falseColor: "#569cd6",
        nullColor: "#569cd6"
    };

    if (props.data) {
        if (displayType === "decimal") {
            let result = "";

            for (let i = 0; i < props.data.byteLength; i++) {
                result += props.data.getUint8(i).toString(10) + ", ";
            }

            value = result;
        }
        else if (displayType === "hex") {
            let result = "0x";

            for (let i = 0; i < props.data.byteLength; i++) {
                const str = props.data.getUint8(i).toString(16);
                const pad = ("00" + str).substr(str.length);

                result += pad;
            }

            value = result;
        }
        else if (displayType === "hex-array") {
            let result = "";

            for (let i = 0; i < props.data.byteLength; i++) {
                const str = props.data.getUint8(i).toString(16);
                const pad = ("00" + str).substr(str.length);

                result += "0x" + pad + ", ";
            }

            value = result;
        }
        else if (displayType === "utf8") {
            const decoder = new TextDecoder();
            const text = decoder.decode(props.data);

            value = text;
        }
        else if (displayType === "msgpack") {
            try {
                const obj = decode(new Uint8Array(props.data.buffer));
                value = formatHighlight(JSON.stringify(obj, undefined, 4), customDarkColorOptions);
                treatAsInner = true;
            }
            catch(ex) {
                value = `Error: ${ex}`;
            }
        }
        else if (displayType === "msgpack-lite") {
            try {
                const obj = decodeLite(new Uint8Array(props.data.buffer));
                value = formatHighlight(JSON.stringify(obj, undefined, 4), customDarkColorOptions);
                treatAsInner = true;
            }
            catch(ex) {
                value = `Error: ${ex}`;
            }
        }
    }
    else {
        value = null;
    }

    return <div class="value-display">
        <div class="type">
            Display type: <select onChange={(e) => setDisplayType(e.currentTarget.value)}>
                <option value="hex">Hex</option>
                <option value="hex-array">Hex Array</option>
                <option value="decimal">Decimal</option>
                <option value="utf8">UTF8</option>
                <option value="msgpack">MsgPack</option>
                <option value="msgpack-lite">MsgPack Lite</option>
            </select>
        </div>
        {treatAsInner ?
            <code style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }} dangerouslySetInnerHTML={{ __html: value }}></code>
            :
            <code style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>{value}</code>
        }
    </div>;
}
